var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.response)?_c('div',{staticClass:"no-answer"},[_c('span',[_vm._v("\n            Not Answered\n        ")])]):_vm._e(),_vm._l((2),function(choice,index){return _c('div',{key:index,class:['choice', {
            selected: _vm.response != null && _vm.response[0] === (choice == 1 ? 'Yes' : 'No')
        }]},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(choice == 1 ? 'Yes' : 'No'))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }